import { Box, Typography } from '@mui/material';
import React from 'react';
import ImageBanner from './ImageBanner';
import Label from '../type/Label';

const ClaimsHeader = () => {
    return (
        <>
        <ImageBanner  title={<Label id='claimsLink'/>}></ImageBanner>
            <Box className='claimsHeaderContainer'>

                <Typography variant='h2' className='claimsTitleText'><Label id="AllClaims"/></Typography>
                {/* <Typography variant='subtitle1' gutterBottom className='claimsText'>A list of all your plan members’ claims.</Typography> */}
            </Box>
        </>
    );
};

export default ClaimsHeader;
